import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const TableHead = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"thead">): ReactElement => (
  <thead
    {...props}
    className={clsx(className, "text-zinc-500 dark:text-zinc-400")}
  />
);
